<template>
<dl :class="['micad_descriptionList',getType(type)]">
  <template v-for="item in items">
    <dt class="micad_descriptionList_label" :key="item.label">{{item.label}}</dt>
    <dd class="micad_descriptionList_value" v-for="value in item.values" :key="value">{{value}}</dd>
  </template>
</dl>
</template>

<script>
export default {
  name: 'Description-list',
  data() {
    return {
      items: [
        { label: "Label 1", values: ["Detail 1a, Detail 1b, Detail 1c"] },
        { label: "Label 2", values: ["Detail 2a, Detail 2b, Detail 2c"] },
        { label: "Label 3", values: ["Detail 3a, Detail 3b, Detail 3c"] },
        { label: "Label 4", values: ["Detail 4a, Detail 4b, Detail 4c"] }
      ]
    }
  },
    props: {
        type: String,
    },
    methods: {
        getType(type) {
            if (type !== undefined) {
                return ' micad_descriptionList_'+type
            }
        }
    }
}
</script>